import React from 'react';
import { withStyles, FormGroup, Select, MenuItem, TextField } from '@material-ui/core';
import {
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  IndeterminateCheckBox,
  ExpandMore as ExpandIcon,
} from '@material-ui/icons';
import NumericFilters from './numericOperatorFilter';
import { OptionsList } from './OptionsList';
import ListSearch from '../../../../../common/MUI/ListSearch';

const styles = theme => ({
    filterContainer:{
        maxWidth:"180px",
        maxHeight: "230px",
        padding: theme.spacing.unit,
        backgroundColor: theme.ModalBGColor,
        overflow:"hidden",
        '& label$checkbox_root$formControlLabel':{
            display:"flex",
            color: theme.TextColor
        },
    },
    checkbox_root: {
        padding: "5px",
        paddingLeft:"0px",
        verticalAlign: "middle",
        height: "100%",
        color: theme.gridIconBorderColor,
        '&$checkbox_checked': {
          color: theme.HeaderSelectedText
        }
      },
      checkbox_checked: {
      },
      checkbox_disabled:{

      },
      formControlLabel:{
          margin:0,
          backgroundColor: theme.ModalBGColor,
          listStyleType:"none",
          display:"flex",
          cursor:"pointer",
          padding: "5px 12px 0px 0px",
          wordBreak:"break-all",
          '& $formControlLabelDisabled,& $checkbox_disabled':{
            color:"inherit",
            opacity:"0.5",
          }
      },
      labelDisabled:{
        cursor:"not-allowed"
      },
      formControlLabelDisabled:{
        color:"inherit",
        opacity:"0.5",
        pointerEvents: "none"
      },
      formControlLabelColor: {
        fontSize: "12px",
        color: theme.TextColor,
        marginTop:"5px"
      },
      button: {
        margin: theme.spacing.unit,
        textTransform: "none",
        flex: "1 1 auto",
        padding:"0",
        minWidth: "45px",
        minHeight: "15px"
      },
      list:{
          overflowX: 'hidden',
          width: '100%',
          paddingLeft:"10px",
          margin: "0",
          '&  $checkbox_root':{
              paddingLeft: "5px"
          }
      },
      numericFilterContainer:{
          backgroundColor:  theme.ModalBGColor,
          display: "inline-grid",
          gridTemplateColumns: "0.75fr 2fr",
          justifyContent:"space-between",
          '&>div':{
            marginRight: "5px"
          }
      },
      multipleInputContainer:{
        gridTemplateColumns: "0.75fr 1fr 1fr"
      },
      paperStyle:{
        backgroundColor: theme.ModalBGColor,
        marginTop: "40px"
      },
      menuItem:{
        paddingTop: "5px",
        paddingBottom: "5px",
        color: theme.TextColor
      },
      selectInput:{
        color: theme.TextColor,
        fontSize: "16px",
        padding: 0,
        paddingLeft:"5px",
        '& ~ $iconStyle':{
            paddingTop: "3px"
        }
      },
      numericInput:{
        paddingLeft:"5px",
        color: theme.TextColor,
        fontSize: "12px",
        height: 24
      },
      selectedColorText:{
        color: theme.HeaderSelectedText
      },
      colorText:{
       color: theme.TextColor,
       '&$selectedColorText':{
            color: theme.HeaderSelectedText
        }
      },
      noOptions:{
          width:"100%",
          height: "100%",
          fontSize: "12px",
          textAlign:"center",
          opacity: 0.6,
          color: theme.TextColor
      },
      iconStyle:{
          fontSize: "16px",
          color: theme.iconColor,
          cursor: "pointer"
      },
      inputLabel:{
        fontSize: "12px",
        color: theme.TextColor,
        opacity: 0.6
      },
      underlineStyle:{
          borderColor: theme.iconColor
      }
});

const MultiSelectComponent = props => {
    const { classes, options } = props;
    const isSelectAllDisabled = options.length === 0;
    const hasSelections = props.options.filter(option=>option.checked).length > 0;
    const hasNumericRange = props.numericOperator && props.numericOperator.needsRange;
    function onNumericFieldKeyPress(event){
        if(!((event.charCode == 8 || event.charCode == 0 ) ? null : (event.charCode >= 48 && event.charCode <= 57 || [45, 46].includes(event.charCode)))){
            event.preventDefault();
        }
    }
    const customWidth = props.colDef?.filterParams?.width;
    return (
        <div className={classes.filterContainer} style={customWidth ? {width: customWidth, maxWidth: "none"} : {}}>
            { !props.isNumericFilter ? (
                <ListSearch onSearch={props.onSearch} value={props.searchTerm} />
             ) : (
                <FormGroup className={`${classes.numericFilterContainer} ${hasNumericRange ? classes.multipleInputContainer : ""}` }>
                    <Select
                        value={props.numericOperator.value}
                        onChange={(event, child) => props.numericOperatorUpdated(child.props.operator)}
                        IconComponent={ExpandIcon}
                        classes={{
                            select: classes.selectInput,
                            icon: classes.iconStyle,
                        }}
                        MenuProps={{
                            disablePortal: true,
                            PopoverClasses:{
                                paper: classes.paperStyle
                            }
                        }}
                    >
                        {
                            NumericFilters.map(filter=>(
                                <MenuItem key={filter.value} value={filter.value} operator={filter} classes={{root: classes.menuItem, selected: classes.selectedColorText}}>{filter.label}</MenuItem>
                            ))
                        }
                    </Select>
                    <TextField
                        label={`${hasNumericRange ? "From" : ""}`}
                        InputProps={{
                            placeholder:`${hasNumericRange ? "" : "Numeric Value" }`,
                            classes:{
                                input: classes.numericInput,
                                underline: classes.underlineStyle
                            }
                        }}
                        InputLabelProps={{
                            classes:{
                                root: classes.inputLabel
                            }
                        }}
                        inputProps={{
                            min:0,
                            onKeyPress: onNumericFieldKeyPress
                        }}
                        type="number"
                        value={props.startRange}
                        onChange={(event)=> props.numericRangeUpdate("startRange",event.target.value)}
                    />
                    {props.numericOperator && props.numericOperator.needsRange && (
                    <TextField
                        label="To"
                        InputProps={{
                            classes:{
                                input: classes.numericInput,
                                underline: classes.underlineStyle
                            }
                        }}
                        InputLabelProps={{
                            classes:{
                                root: classes.inputLabel
                            }
                        }}
                        inputProps={{
                            min:0,
                            onKeyPress: onNumericFieldKeyPress
                        }}
                        type="number"
                        value={props.endRange}
                        onChange={(event)=>props.numericRangeUpdate("endRange",event.target.value)}
                    />
                    )}
                </FormGroup>
            )}
                <div className={`${isSelectAllDisabled ? classes.labelDisabled : ""}`}>
                <div onClick={()=>props.onSelectAll(!hasSelections)} className={`${classes.formControlLabel} ${isSelectAllDisabled ? classes.formControlLabelDisabled : ''}`}>
                    <span className={`${classes.checkbox_root} ${hasSelections ? classes.checkbox_checked :'' }`}>
                        {hasSelections ?
                            <IndeterminateCheckBox color="primary"/> :
                            <CheckBoxOutlineBlankIcon />
                        }
                    </span>
                    <span className={classes.formControlLabelColor}>{  hasSelections ? "CLEAR ALL" : "SELECT ALL"}</span>
                </div>
                </div>
                <OptionsList 
                    options ={options}
                    onOptionSelected={props.onOptionSelected}
                    classes={classes}
                    listHeight={130} // Max height of 130px for the dropdown list
                    optionsRenderer = {props.optionsRenderer}
                />
        </div>
    )
}

export default withStyles(styles)(MultiSelectComponent);